import {Component, Input, OnInit} from '@angular/core';
import { OptionService } from "../option/option.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'fullscreentext',
    templateUrl: './output.fullscreentext.component.html'
})
export class FullscreenTextComponent implements OnInit {
    /**
     * the current step
     */
    @Input() step: string;

    /**
     * List of steps on that this component ist visible
     * @type {[string,string]}
     */
    showOnSteps = ["dataprotection", "impress"];

    /**
     * That text that should be visible
     * @type {string}
     */
    text: string = null;

    /**
     * Current uses language
     * @type {string}
     */
    language: string = "de";

    /**
     * Constructor
     * @param optionService
     * @param translationService
     */
    constructor(private optionService: OptionService, private translationService: TranslateService) {}

    /**
     * is calles when initalizing the component
     */
    public ngOnInit(): void {
        this.language = this.translationService.getBrowserLang();
    }

    /**
     * is called when initializing the component
     */
    public getText(): string {
        // depending on the step weh show another text
        if(this.step == "impress") {
            // Show Impress
            let legalForm = this.optionService.getOrganisationData("legal_form")? this.optionService.getOrganisationData("legal_form") : "";
            this.text = this.optionService.getOrganisationData("name") + " " + legalForm + "<br>";
            this.text += this.optionService.getOrganisationData("street") + "<br>";
            this.text += this.optionService.getOrganisationData("postal_code") + " " + this.optionService.getOrganisationData("city") + "<br>";
            // this.text += this.optionService.getOrganisationData("contact_email");

            // link to impress of the orga
            let impressUrl = this.optionService.getOrganisationData("impress_url");
            if(impressUrl) {
                this.text += "<br><br>" + this.translationService.instant("impress.urlprefix");
                this.text += "<br><a href='" + impressUrl + "' target='_blank'>" + impressUrl + "</a>";
            }
        }
        else if(this.step == "dataprotection") {
            // show text for dataprotection
            let legalForm = this.optionService.getOrganisationData("legal_form")? this.optionService.getOrganisationData("legal_form") : "";
            this.text = this.translationService.instant("dataprotection", {
                //email: this.optionService.getOrganisationData("contact_email"),
                organisation: this.optionService.getOrganisationData("name") + " " + legalForm,
                address: this.optionService.getOrganisationData("street") + "<br>" + this.optionService.getOrganisationData("postal_code") + " " + this.optionService.getOrganisationData("city")
            });
        }
        return this.text;
    }

    /**
     * Decide if the component should be visible or not
     *
     * @returns {boolean}
     */
    showComponent(): boolean {
        return this.showOnSteps.indexOf(this.step) != -1;
    }

}
